"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buyNowCreator = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var consts_1 = require("../consts");
var ONE_CLICK_CHECKOUT = 'one-click-checkout';
var buyNowCreator = function (event) {
    var eventData = {
        action: analytics_layer_1.CommerceInteractionEventNames.BuyNow,
        event: 'buy-now',
        eventInfo: 'buy-now',
        cart: {
            currency: event.eventData.cart.currency || consts_1.NOT_AVAILABLE,
            checkoutType: event.eventData.cart.checkoutType || ONE_CLICK_CHECKOUT,
            product: event.eventData.cart.product.map(function (item) { return (__assign(__assign({}, item), { bundledProduct: item.bundledProduct || consts_1.NOT_AVAILABLE })); }),
        },
    };
    return [eventData];
};
exports.buyNowCreator = buyNowCreator;
